<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        <template v-if="priceData.id">{{ $t('price.editPrice') }}</template>
        <template v-else>{{ $t('price.addPrice') }}</template>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="customer-price-form" tag="form">
          <div class="form-group">
            <label for="name">
              {{ $t('customer.product') }}:
            </label>

            <validation-provider
              rules="required"
              name="product-id"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                <v-select
                  v-model="product_id"
                  :state="errors.length ? 'invalid' : null"
                  :reduce="(product) => product.id"
                  :placeholder="$t('product.chooseProduct')"
                  label="code"
                  :options="products" />
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('price.price') }}:
            </label>

            <validation-provider
              rules="required"
              name="price"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="price" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="saveInProgress"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="saveInProgress"
        @click.prevent="validateForm">
        <div
          v-if="saveInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        {{ $t('ui.save') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-price-popup',
  props: {
    priceData: {
      default: () => ({}),
      type: Object
    },
    customerId: {
      default: 0,
      type: Number
    },
    products: {
      default: () => ([]),
      type: Array
    }
  },
  data () {
    return {
      product_id: null,
      price: 0,
      saveInProgress: false
    };
  },
  mounted () {
    this.product_id = this.priceData.product_id || null;
    this.price = this.priceData.price || 0;
    this.saveInProgress = false;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('customer-price-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-price-form'], this.save);
    },
    save () {
      this.saveInProgress = true;

      let formData = {
        customer_id: this.customerId,
        product_id: this.product_id,
        price: (this.price).toString().replace(',', '.')
      };

      let endpoint = '/customers/prices/store';

      if (this.priceData.id) {
        endpoint = '/customers/prices/update/' + parseInt(this.priceData.id, 10);
      }

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint,
        formData,
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('ui.saveChangesErrorText'),
        successAction: () => {
          this.saveInProgress = false;
          this.$bus.$emit('customer-prices-reload-needed');
          this.cancel();
        },
        failAction: () => {
          this.saveInProgress = false;
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
